<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.billingName' | translate }}
  </label>
  <input type="text" class="form-control" id="billingName" formControlName="billingName"  [ngClass]="{ 'is-invalid': campaignForm.get('billingName')?.invalid}" />
  <input type="checkbox" class="form-check-input" formControlName="billingNameChecked" (change)="checkboxClicked()" id="billingNameId"> <label class="form-check-label" for="billingNameId">{{'campaign.useName' | translate}}</label>
  <div class="invalid-feedback" translate="field.required"></div>
</div>
